// Centralised copy reused verbatim from cfladgroup.com

export const HERO_CONTENT = {
    eyebrow: 'CFL Ad Group · Melbourne, FL',
    title: 'Direct Response Advertising Strategies',
    subtitle:
        'Direct response advertising agency, specializing in traditional television (infomercials and TV spots), Short Form Direct Response, Social Media and Marketing Videos.',
    primaryCta: 'Schedule a Call',
    secondaryCta: 'See Our Work',
};

export const PILLARS = [
    {
        key: 'brand',
        number: '01',
        title: 'Building Your Brand',
        body:
            'By far the most overlooked and under appreciated aspect of creating a marketing strategy for any business is brand building. How do you want your customers to feel about doing business with you? What do you want them to think about your company that makes you stand out from all the rest? Here are a few tips to help you…',
    },
    {
        key: 'media',
        number: '02',
        title: 'VHF, UHF, CTV, CCTV, OTT… OMFG!',
        body:
            'Don’t worry, CFL Ad Group is here to help. With expertise in all forms of media, including traditional and emerging platforms, we create effective advertising solutions that drive results for automotive dealerships. Trust us to deliver your message to the right audience, on the right platform, at the right time.',
    },
    {
        key: 'social',
        number: '03',
        title: 'Social Media',
        body:
            'Social media has become an essential part of our daily lives, and its importance in business cannot be overstated. For any business, social media platforms provide an excellent opportunity to connect with potential customers and build brand awareness. CFL Ad Group can help your business establish a strong online presence and reach a wider audience.',
    },
];

export const WHAT_WE_DO = [
    {
        title: 'Brand Perception',
        body:
            'We shape how the market sees you — crafting a positioning, voice, and visual identity that earns attention and stays memorable long after the spot ends.',
    },
    {
        title: 'Investments & Acquisitions',
        body:
            'We offer comprehensive marketing and communication strategies for mergers, acquisitions, and investments, ensuring a smooth transition and a strong brand presence in the marketplace.',
    },
    {
        title: 'Crisis Management',
        body:
            'We provide expert crisis management support, ensuring your brand maintains a positive reputation and image during times of unexpected events or negative publicity.',
    },
    {
        title: 'Launch Success',
        body:
            'We ensure your product launch is a success by crafting a compelling campaign that generates buzz and drives engagement.',
    },
    {
        title: 'Customer Reach',
        body:
            'We expand your customer reach through data-driven strategies and targeted advertising that effectively communicates your message to the right audience.',
    },
    {
        title: 'Growth & Sales',
        body:
            'We help grow your business and increase sales by developing and executing effective marketing strategies that generate quality leads and drive conversions.',
    },
];

export const ABOUT_TEXT = {
    eyebrow: 'About Us',
    headline: 'Over 30 years putting dealerships in front of the right audience.',
    body:
        'With over 30 years of experience, CFL Ad Group has established itself as a leader in the automotive advertising industry. Our expertise in direct response marketing, coupled with our commitment to personalized service, sets us apart from the competition. We pride ourselves on getting to know our clients and their unique needs, so we can create custom marketing solutions that generate real results. Our team of professionals is dedicated to providing the highest level of service, and we are passionate about helping automotive dealerships reach their full potential. Trust CFL Ad Group to deliver effective, data-driven marketing strategies that will drive growth and increase sales for your business.',
    stats: [
        { value: '30+', label: 'Years in business' },
        { value: '500+', label: 'Spots produced' },
        { value: '120+', label: 'Dealerships served' },
        { value: '48hr', label: 'Avg. turnaround' },
    ],
};

export const INDUSTRIES = [
    {
        key: 'automotive',
        title: 'Automotive',
        body:
            'CFL Ad Group specializes in automotive advertising, offering comprehensive marketing solutions that help dealerships drive sales and increase revenue through data-driven strategies and personalized service.',
        image: 'https://images.unsplash.com/photo-1567789884554-0b844b597180?w=1200&q=80',
    },
    {
        key: 'enterprise',
        title: 'Enterprise Companies',
        body:
            'CFL Ad Group provides comprehensive marketing solutions for Enterprise Companies, leveraging our expertise in direct response and personalized service to deliver effective campaigns that drive growth and increase revenue.',
        image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80',
    },
    {
        key: 'consumer',
        title: 'Consumer Products',
        body:
            'CFL Ad Group offers data-driven marketing solutions for Consumer Product companies, helping them expand their customer base and increase sales through targeted messaging and effective communication strategies.',
        image: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1200&q=80',
    },
    {
        key: 'emerging',
        title: 'Emerging Technology',
        body:
            'CFL Ad Group provides marketing solutions for Emerging Technologies companies, leveraging our expertise in digital advertising and data-driven strategies to help them succeed in a constantly evolving marketplace.',
        image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80',
    },
];

export const TESTIMONIAL = {
    quote: 'CFL Ad Group took my dealerships to the next level!',
    author: 'General Manager',
    org: 'Multi-rooftop Automotive Group',
};

export const CLIENT_LOGOS = [
    'APEX MOTORS',
    'STELLAR MEDIA',
    'QUANTUM AUTO',
    'NORTHRIDGE GROUP',
    'HARBOR DEALERSHIPS',
    'IRONWORKS BROADCAST',
    'MERIDIAN AUTO',
    'BLUEPRINT MEDIA',
];

// Real video IDs from https://www.youtube.com/@cfladgroup8350/videos
export const FEATURED_VIDEO_ID = 'uE_FJ8pQOrw';

export const WORK_VIDEOS = [
    { id: 'uE_FJ8pQOrw', title: 'CFL Ad Group — Featured Reel' },
    { id: '61JENhdfveU', title: 'Direct Response Dealer Spot' },
    { id: '1WabPVHCkiY', title: 'Automotive Campaign Highlight' },
    { id: 'J1PSVs-Yn5Y', title: 'Long-form Infomercial' },
    { id: '_3r1BlGKQGk', title: 'Sales Event Promo' },
    { id: 'hobOjTDrXWs', title: 'Model-Year Launch' },
    { id: 'UaBcald5kXs', title: 'Brand Anthem Spot' },
    { id: 'I0DT5OD6vBA', title: 'Service Department Spot' },
    { id: 'rK7qCN_Is1E', title: 'Pre-owned Inventory Push' },
    { id: 'tWFi_F20O98', title: 'Quarterly Sales Event' },
    { id: 'uE_FJ8pQOrw', title: 'Customer Testimonial Cut' },
    { id: '61JENhdfveU', title: 'Holiday Sales Drive' },
];

export const YOUTUBE_CHANNEL = 'https://www.youtube.com/@cfladgroup8350/videos';

export const ARTICLES = [
    {
        slug: 'long-form',
        title: 'Long Form!',
        excerpt:
            'When it comes to marketing your automotive dealership, you want to make sure you’re using the most effective strategies to drive traffic and generate sales. One marketing tool that has been gaining traction in recent years is the long-form infomercial. Unlike…',
        image: '/assets/cfl-studio.webp',
        readTime: '6 min read',
        date: 'Feature',
    },
    {
        slug: 'direct-response-vs-brand',
        title: 'Direct Response vs. Brand: Why You Need Both',
        excerpt:
            'Most dealerships are forced to pick a side — performance or brand. The reality? Modern direct response only compounds when paired with a strong brand foundation. Here’s how we balance the two.',
        image: '/assets/cfl-dealership.webp',
        readTime: '4 min read',
        date: 'Insight',
    },
    {
        slug: 'ctv-buying-guide',
        title: 'The CTV Buying Guide for Dealerships',
        excerpt:
            'CTV, OTT, FAST channels — the acronyms keep growing, but the playbook doesn’t have to be complicated. A practical buying framework you can use this quarter.',
        image: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?w=1200&q=80',
        readTime: '5 min read',
        date: 'Playbook',
    },
];

export const CONTACT_INFO = {
    address1: '2825 Business Center Blvd.',
    address2: 'Suite C4',
    address3: 'Melbourne, FL 32940',
    phone: '321-288-1735',
    phoneHref: 'tel:+13212881735',
    email: 'mike@cfladgroup.com',
    emailHref: 'mailto:mike@cfladgroup.com',
};

// Real client photography (provided by CFL Ad Group)
export const IMAGERY = {
    // Hero / About — production studio with car & host
    studio: '/assets/cfl-studio.webp',
    // Dealership / on-location production
    dealership: '/assets/cfl-dealership.webp',
    // Industry visuals
    industries: {
        automotive: 'https://images.unsplash.com/photo-1567789884554-0b844b597180?w=1200&q=80',
        enterprise: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80',
        consumer: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1200&q=80',
        emerging: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80',
    },
};
